import {Theme} from "@material-ui/core";

export const FONT_FAMILY = "'Metropolis', 'Helvetica', 'Arial', sans-serif";

/* All theme colors below resolve to CSS variables defined in src/index.css.
   Light/dark values live there. Person colors (parent.color / kid.color
   from family data) are deliberately kept out of this file — they remain
   user-defined and unchanged across themes. */

// Greys
export const GREY_LIGHT = "var(--color-greyLight)";
export const GREY = "var(--color-grey)";
export const GREY_DARK = "var(--color-greyDark)";

// Functional colors
export const GREEN = "var(--color-green)";
export const BLUE = "var(--color-blue)";

// Additional system colors
export const INDIGO = "var(--color-indigo)";
export const VIOLET = "var(--color-violet)";
export const YELLOW = "var(--color-yellow)";

// Basic colors
export const BLACK = "var(--color-black)";
export const WHITE = "var(--color-white)";

// Brand palette
export const PURPLE_200 = "var(--color-purple200)";
export const PURPLE_400 = "var(--color-purple400)";
export const PURPLE_900 = "var(--color-purple900)";

export const CORAL_500 = "var(--color-coral500)";
export const CORAL_700 = "var(--color-coral700)";
export const CORAL_600 = "var(--color-coral600)";
export const CORAL_800 = "var(--color-coral800)";

export const BEIGE_400 = "var(--color-beige400)";

export const blueBackgroundColor = "var(--color-blueBackground)";
export const primaryColor = CORAL_800;
export const secondaryColor = PURPLE_900;
export const errorColor = CORAL_600;
export const grayColor = "var(--color-grayColor)";
export const beigeColor = BEIGE_400;

export const styleColors = {
  // Base
  transparent: "transparent",
  transparentWhite: "var(--color-transparentWhite)",
  transparentBlack: "var(--color-transparentBlack)",
  white: "var(--color-white)",
  black: "var(--color-black)",

  whiteOverlay28: "var(--color-whiteOverlay28)",
  whiteShimmer60: "var(--color-whiteShimmer60)",
  whiteOverlay72: "var(--color-whiteOverlay72)",
  whiteText82: "var(--color-whiteText82)",

  // Greys, lightest to darkest
  warmGrey: "var(--color-warmGrey)",

  greyLight1: "var(--color-greyLight1)",
  greyLight2: "var(--color-greyLight2)",
  greyLight3: "var(--color-greyLight3)",
  greyMedium1: "var(--color-greyMedium1)",
  greyMedium2: "var(--color-greyMedium2)",
  greyMedium3: "var(--color-greyMedium3)",
  greyDark1: "var(--color-greyDark1)",
  greyDark2: "var(--color-greyDark2)",
  greyDark3: "var(--color-greyDark3)",

  guideCellBackground: "var(--color-guideCellBackground)",
  guideCellSelected: "var(--color-guideCellSelected)",
  dialogBackdropGrey: "var(--color-dialogBackdropGrey)",
  lightGreyOverlay: "var(--color-lightGreyOverlay)",
  calendarLineTransparent: "var(--color-calendarLineTransparent)",
  calendarLineSubtle: "var(--color-calendarLineSubtle)",
  calendarLineStrong: "var(--color-calendarLineStrong)",
  greyShadow28: "var(--color-greyShadow28)",
  greyOverlay35: "var(--color-greyOverlay35)",

  // Black and shadows, lightest to darkest
  blackAlpha12: "var(--color-blackAlpha12)",
  blackAlpha18: "var(--color-blackAlpha18)",
  blackAlpha23: "var(--color-blackAlpha23)",
  outlineBlack23: "var(--color-outlineBlack23)",
  blackInset33: "var(--color-blackInset33)",
  shadowBlack42: "var(--color-shadowBlack42)",
  blackAlpha45: "var(--color-blackAlpha45)",
  blackAlpha63: "var(--color-blackAlpha63)",
  scrimBlack63: "var(--color-scrimBlack63)",
  blackAlpha75: "var(--color-blackAlpha75)",
  primaryTextBlack87: "var(--color-primaryTextBlack87)",
  blackAlpha93: "var(--color-blackAlpha93)",

  charcoalAlpha29: "var(--color-charcoalAlpha29)",


  // Purples, lightest to darkest
  lavenderAlpha20: "var(--color-lavenderAlpha20)",
  mutedMauve: "var(--color-mutedMauve)",
  neonPurpleAlpha20: "var(--color-neonPurpleAlpha20)",
  neonPurpleAlpha27: "var(--color-neonPurpleAlpha27)",
  neonPurpleAlpha33: "var(--color-neonPurpleAlpha33)",
  neonPurple: "var(--color-neonPurple)",
  vividPurpleAlpha13: "var(--color-vividPurpleAlpha13)",
  vividPurple: "var(--color-vividPurple)",
  softPurpleShadow: "var(--color-softPurpleShadow)",
  chromePurpleShadow: "var(--color-chromePurpleShadow)",
  deepPurpleAlpha47: "var(--color-deepPurpleAlpha47)",
  deepPurpleAlpha65: "var(--color-deepPurpleAlpha65)",
  deepPurple: "var(--color-deepPurple)",
  darkPurple: "var(--color-darkPurple)",

  // Beiges, lightest to darkest
  lightBeige: "var(--color-lightBeige)",

  // Corals and reds, lightest to darkest
  paleCoral: "var(--color-paleCoral)",
  brightCoralTint12: "var(--color-brightCoralTint12)",
  coralShadowSoft: "var(--color-coralShadowSoft)",
  coral800: "var(--color-coral800Solid)",
  mutedCoral: "var(--color-mutedCoral)",
  brightCoral: "var(--color-brightCoral)",
  brightCoralBorder: "var(--color-brightCoralBorder)",
  fabShadow: "var(--color-fabShadow)",
  coralRed: "var(--color-coralRed)",
  callRed: "var(--color-callRed)",
  materialRed: "var(--color-materialRed)",
  pureRed: "var(--color-pureRed)",
  redShadow23: "var(--color-redShadow23)",

  // Blues, lightest to darkest
  blueTint12: "var(--color-blueTint12)",
  softPeriwinkle: "var(--color-softPeriwinkle)",
  cornflowerBlue: "var(--color-cornflowerBlue)",
  steelBlue: "var(--color-steelBlue)",
  actionBlue: "var(--color-actionBlue)",
  externalCalendarBlue: "var(--color-externalCalendarBlue)",

  // Greens, lightest to darkest
  callGreen: "var(--color-callGreen)",
  successGreen: "var(--color-successGreen)",

  // Yellows, lightest to darkest
  softYellowTint12: "var(--color-softYellowTint12)",
  softYellow: "var(--color-softYellow)",
  softYellowBorder: "var(--color-softYellowBorder)",
  handoverYellow: "var(--color-handoverYellow)",

  // Rainbow and multicolor gradients
  rainbowCyan: "var(--color-rainbowCyan)",
  rainbowGreen: "var(--color-rainbowGreen)",
  rainbowLime: "var(--color-rainbowLime)",
  rainbowOrange: "var(--color-rainbowOrange)",
  rainbowMagenta: "var(--color-rainbowMagenta)",
  rainbowViolet: "var(--color-rainbowViolet)",
  rainbowBlue: "var(--color-rainbowBlue)",

  // Premium, active subscription card
  premiumStart: "var(--color-premiumStart)",
  premiumMiddle: "var(--color-premiumMiddle)",
  premiumEnd: "var(--color-premiumEnd)",
  premiumGlow: "var(--color-premiumGlow)",
  premiumText: "var(--color-premiumText)",
} as const;

export const boxShadow = {
  boxShadow:
    `0 10px 30px -12px ${styleColors.shadowBlack42}, ` +
    `0 4px 25px 0px ${styleColors.blackAlpha12}, ` +
    `0 8px 10px -5px ${styleColors.blackAlpha18}`
} as const;

export const fullViewportColumn = {
  maxHeight: "100vh",
  height: "100vh",
  minHeight: "100vh",
  width: "100vw",
  maxWidth: "100vw",
  minWidth: "100vw",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  position: "relative",
} as const;

export const topCornerMask = {
  height: "40px",
  width: "100%",
  overflow: "hidden",
  position: "fixed",
  left: 0,
  top: "0px",
  pointerEvents: "none",
} as const;

export const topCornerBend = (theme: Theme) => ({
  height: "40px",
  width: "100%",
  boxShadow: `0 0 0 40px ${styleColors.greyLight2}`,
  borderRadius: "40px 40px 0 0",
  overflow: "hidden",
  [theme.breakpoints.up("md")]: {
    borderRadius: 0,
  },
} as const);

export const greyInput = {
  margin: "2px",
  display: "flex",
  alignItems: "center",
  backgroundColor: styleColors.greyLight2,
  border: "none",
  padding: "4px 6px",
  lineHeight: "22px",
  borderRadius: "3px",
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: FONT_FAMILY,
} as const;

export const buttonOutlined = {
  border: `1px solid ${styleColors.outlineBlack23}`,
  padding: "5px 15px",
  borderRadius: "99px",
  flex: 1,
} as const;

export const buttonContained = {
  border: `1px solid ${styleColors.outlineBlack23}`,
  padding: "5px 15px",
  borderRadius: "99px",
  flex: 1,
} as const;

export const buttonOutlinedLarge = {
  border: `1px solid ${styleColors.outlineBlack23}`,
  padding: "8px 22px",
  fontSize: "16px",
  borderRadius: "99px",
  flex: 1,
  Letterspacing: "1px"
} as const;

export const buttonContainedLarge = {
  border: `1px solid ${styleColors.outlineBlack23}`,
  padding: "8px 22px",
  fontSize: "14px",
  borderRadius: "99px",
  flex: 1,
  Letterspacing: "1px",
} as const;

export const dialogTitle = {
  fontWeight: 500,
  color: styleColors.primaryTextBlack87,
  margin: 0,
  padding: "16px 24px",
  flex: "1 1 0%",
  fontSize: "16px",
  fontStyle: "normal",
  lineHeight: "16px",
} as const;

export const wordpressContentBase = {
  ".wp-block-pullquote": {
    marginInlineStart: "0px",
    marginInlineEnd: "0px",
    borderStyle: "solid",
    borderWidth: "2px 0px",
  },
  ".wp-block-button__link": {
    textDecoration: "none!important",
    backgroundColor: styleColors.coral800,
    overflowWrap: "break-word",
    display: "inline-block",
    fontWeight: 300,
    color: styleColors.white,
    textAlign: "center",
    verticalAlign: "middle",
    WebkitUserSelect: "none",
    MsUserSelect: "none",
    userSelect: "none",
    padding: ".375rem .75rem",
    fontSize: "1rem",
    lineHeight: "1.5",
    borderRadius: "999px",
    transition: "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  },
  blockquote: {
    marginInlineStart: "40px",
    marginInlineEnd: "40px",
  },
} as const;

export const typography = {
  heading1: {
    fontFamily: FONT_FAMILY,
    fontSize: "2.563rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  heading2: {
    fontFamily: FONT_FAMILY,
    fontSize: "2rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  heading3: {
    fontFamily: FONT_FAMILY,
    fontSize: "1.5rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  heading4: {
    fontFamily: FONT_FAMILY,
    fontSize: "1.125rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  subtitle1: {
    fontFamily: FONT_FAMILY,
    fontSize: "1.0625rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  body1: {
    fontFamily: FONT_FAMILY,
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.25rem",
  },
  input: {
    fontFamily: FONT_FAMILY,
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  },
  placeholder: {
    fontFamily: FONT_FAMILY,
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  label: {
    fontFamily: FONT_FAMILY,
    fontSize: "0.9375rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  feedback: {
    fontFamily: FONT_FAMILY,
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  },
  button: {
    fontFamily: FONT_FAMILY,
    fontSize: "0.875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    letterSpacing: "0.09375rem",
  },
} as const;



// WEBPACK FOOTER //
// ./src/main.style.ts